import { useState, useEffect } from "react";

const MediaImage = ({ media }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const imageTypes = [".jpg", ".jpeg", ".png", ".bmp", ".webp"];

  useEffect(() => {
    if (!media) return;

    const fetchImage = async () => {
      try {
        const response = await fetch(`https://artofbetting.gr/api/media${media}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });

        if (!response.ok) throw new Error("Failed to load image");

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setImageSrc(url);
      } catch (error) {
        console.error("Error loading image:", error);
      }
    };

    fetchImage();
  }, [media]); // Τρέχει ξανά κάθε φορά που αλλάζει το `media`

  return imageSrc ? (
    media && imageTypes.some(type => media.toLowerCase().endsWith(type)) ? (
      <img
        src={imageSrc}
        alt="Media"
        className="mt-4 max-h-[500px] w-auto h-auto rounded-lg shadow-lg"
      />
    ) : (
      <video
        src={imageSrc}
        autoPlay
        loop
        muted
        playsInline
        className="mt-4 max-h-[500px] w-auto h-auto rounded-lg shadow-lg"
      />
    )
  ) : (
    <p>Loading image...</p>
  );
};

export default MediaImage;
